import { Component, type ReactNode } from 'react';

interface Props { children: ReactNode }
interface State { error: Error | null; componentStack: string | null }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, componentStack: null };

  static getDerivedStateFromError(error: Error): State {
    return { error, componentStack: null };
  }

  componentDidCatch(error: Error, info: { componentStack?: string }) {
    console.error('ErrorBoundary caught:', error, info);
    this.setState({ componentStack: info.componentStack || null });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 40, fontFamily: 'monospace', fontSize: 13, color: '#333', maxWidth: 900, margin: '0 auto' }}>
          <h2 style={{ color: '#e63946', marginBottom: 16 }}>页面渲染出错</h2>
          <div style={{ marginBottom: 16 }}>
            <strong>错误信息：</strong>{this.state.error.message}
          </div>
          {this.state.componentStack && (
            <div style={{ marginBottom: 16 }}>
              <strong>组件堆栈：</strong>
              <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', background: '#f5f5f5', padding: 12, borderRadius: 8 }}>
                {this.state.componentStack}
              </pre>
            </div>
          )}
          <div style={{ marginBottom: 16 }}>
            <strong>调用堆栈：</strong>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', background: '#f5f5f5', padding: 12, borderRadius: 8 }}>
              {this.state.error.stack}
            </pre>
          </div>
          <button
            onClick={() => {
              localStorage.removeItem('xishia_authToken');
              localStorage.removeItem('xishia_currentProjectId');
              this.setState({ error: null, componentStack: null });
              window.location.href = '/';
            }}
            style={{ marginTop: 8, padding: '8px 16px', background: '#e63946', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', marginRight: 8 }}
          >
            清除登录态并刷新
          </button>
          <button
            onClick={() => { this.setState({ error: null, componentStack: null }); window.location.reload(); }}
            style={{ marginTop: 8, padding: '8px 16px', background: '#666', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer' }}
          >
            刷新页面
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
